<script setup>
const props = defineProps({
  id: {
    type: String,
    required: true,
  },
})
</script>

<template>
<div>
  <a
    :href="route('auctions.index')"
    class="font-normal px-4 py-1.5 whitespace-nowrap sm:font-medium sm:text-sm no-underline hover:text-gray-900 hover:underline"
  >
    {{ __('Categories') }}
  </a>
</div>
</template>
